let _store = null;

export function useFaqStore(Vue) {
	if (_store) return _store;

	const state = Vue.reactive({
		searchQuery: '',
		searchResultCount: 0,
		searchTexts: {},
		searchItems: {},
		searchResults: [],
		searchLabels: { results: '', no_results: '', min_chars: '' },
		categoriesActiveItem: (window.location.hash && !window.location.hash.startsWith('#popular_') && !window.location.hash.startsWith('#search_')) ? window.location.hash : '',
		searchActiveItem: '',
		popularActiveItem: window.location.hash && window.location.hash.startsWith('#popular_') ? window.location.hash : '',
		expanded: { l1: '', l2: '' },

		matchesSearch(itemHash) {
			if (!state.searchQuery) return true;
			const text = state.searchTexts[itemHash] || '';
			if (!text) return true;
			return text.indexOf(state.searchQuery) !== -1;
		},

		resultsLabel() {
			return state.searchLabels.results.replace('%1$s', state.searchQuery);
		},

		noResultsLabel() {
			return state.searchLabels.no_results.replace('%1$s', state.searchQuery);
		},

		minCharsLabel() {
			return state.searchLabels.min_chars.replace('%1$s', state.searchQuery.length < 2 ? '2' : '');
		},

		clearSearch() {
			state.searchQuery = '';
			state.searchResultCount = 0;
			state.searchResults = [];
		},

		isOpen(itemHash) {
			if (itemHash.startsWith('l1:')) return state.expanded.l1 === itemHash.slice(3);
			if (itemHash.startsWith('l2:')) return state.expanded.l2 === itemHash.slice(3);
			if (itemHash.startsWith('#search_')) return state.searchActiveItem === itemHash;
			if (itemHash.startsWith('#popular_')) return state.popularActiveItem === itemHash;
			return state.categoriesActiveItem === itemHash;
		},

		expandForSearch(itemHash) {
			_expandParents(itemHash, state);
		},

		toggle(itemHash) {
			if (itemHash.startsWith('l1:')) {
				state.expanded.l1 = state.expanded.l1 === itemHash.slice(3) ? '' : itemHash.slice(3);
				return;
			}
			if (itemHash.startsWith('l2:')) {
				state.expanded.l2 = state.expanded.l2 === itemHash.slice(3) ? '' : itemHash.slice(3);
				return;
			}
			if (itemHash.startsWith('#search_')) {
				state.searchActiveItem = state.searchActiveItem === itemHash ? '' : itemHash;
				return;
			}
			if (itemHash.startsWith('#popular_')) {
				state.popularActiveItem = state.popularActiveItem === itemHash ? '' : itemHash;
				if (itemHash) window.location.hash = itemHash;
				return;
			}
			if (itemHash.startsWith('#')) {
				if (state.categoriesActiveItem === itemHash) {
					state.categoriesActiveItem = '';
					return;
				}
				_expandParents(itemHash, state);
				state.categoriesActiveItem = itemHash;
				window.location.hash = itemHash;
			}
		},
	});

	window.addEventListener('hashchange', () => {
		const hash = window.location.hash || '';
		if (!hash || !hash.startsWith('#') || hash.startsWith('#search_')) return;
		if (hash.startsWith('#popular_')) {
			state.popularActiveItem = hash;
			return;
		}
		_expandParents(hash, state);
		state.categoriesActiveItem = hash;
	});

	if (state.categoriesActiveItem) {
		_expandParents(state.categoriesActiveItem, state);
	}

	_store = state;
	return _store;
}

function _expandParents(hash, state) {
	const m = hash.match(/^#([a-z])(\d*)_/);
	if (!m) return;
	state.expanded.l1 = m[1];
	state.expanded.l2 = m[2] ? m[1] + m[2] : '';
}